<script>
export default {
  computed: {
    condition() {
      return this.mappedVariants.join(' ')
    },
    answers() {
      return this.data.metadata.variants.filter((variant) => variant.type === "answer");
    },

    mappedVariants() {
      return this.data.metadata.variants.map((variant, index) => {
        if (variant.type === "answer") {
          return `<span class="answer-index"></span>`
        }

        return variant.value.replace(/<p>(.*?)<\/p>/g, function (match, p1) {
          return (p1 === '&nbsp;') ? match : p1;
        });
      })
    }
  }
};
</script>

<style>
.answer-index {
  min-width: 4vw;
  display: inline-block;
  text-align: center;
  border-bottom: 1px solid;
  color: #818181;
  font-size: 15.73px;
}
</style>
